import styled from 'styled-components';

export const MapStyle = styled.div`
  display: flex;
  flex-direction: column;

  .map-cont {
    position: relative;
  }
`;

export const FlowStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .flow-body {
    flex: 1;
    position: relative;
  }

  .react-flow__controls {
    left: var(--size-lg);
    bottom: var(--size-lg);
  }
`;

export const ListStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TableStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .ant-table-container {
    .ant-table-thead {
      .ant-table-cell {
        background: #F5F5F5 !important;
      }
    }
  }

  .view-btn-scl-table {
    svg {
      margin-top: -4px;
    }
  }

  .ant-pagination-item-link svg {
    margin-top: -4px;
  }

  .ant-table-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;

    .ant-spin-nested-loading {
      flex: 1;
      display: flex;
      flex-direction: column;

      .ant-spin-container {
        flex: 1;
        display: flex;
        flex-direction: column;

        .ant-table {
          height: 536px;
          overflow-y: auto;

          thead {
            position: sticky;
            top: 0px;
            z-index: 100;
          }
        }
      }

    }
  }

`;

export const BtnTabsStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: var(--size-lg);
`;

export default styled.div`
  min-height: 656px;
  display: flex;
  flex-direction: column;

  .header-tab-cont {
    min-width: 100px;
  }

  .ant-tabs-nav {
    margin-bottom: 0px;
  }

  .ant-tabs-tab {
    font-size: var(--font-size-lg);
    padding: 0px 0px 6px 0px;
  }
`;

export const MapContStyle = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  overflow: hidden;
  
  .leaflet-bottom {
    z-index: 500;
  }
  
  .map-handlers { 
    position: absolute;
    top: var(--size-lg);
    left: var(--size-lg);
    z-index: 500;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    transition: .2s right;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

    button {
      background: white;
      border: 0px;
      border-bottom: 1px solid #CECECE;
      display: flex;
      flex-direction: column;
      padding: 12px 10px;
      outline: none;

      &.up {
        border-bottom: 0px;
        padding-bottom: 4px;
      }

      &.down {
        border-bottom: 0px;
        padding-top: 4px;
        color: #B4B4B4;
      }
    }
  }

  .sider {
    background: white;
    max-width: 230px;
    padding: 9px;
    height: 82%;
    box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
    border-radius: 4px 0px 0px 4px;
    display: flex;
    flex-direction: column;
    transition: .4s right;
    top: 9%;
    right: -230px;
    position: absolute;
    z-index: 500;
    overflow-y: auto;

    &.toggled {
      right: 0px;
    }

    .sider-body {
      margin: var(--size-lg);
      margin-bottom: var(--size);
      flex: 1;
      display: flex;
      flex-direction: column;

      h2 {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 8px;
        color: #001529;
      }

      h3 {
        color: #111927;
        font-weight: 500;
        font-size: 11px;
        margin-bottom: var(--size-lg);
      }

      .row-items {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .row-item {
          label {
            color: #667085;
            font-size: 11px;
            font-weight: 500;
            margin-bottom: 8px;
          }
          
          p {
            color: #111927;
            font-size: 11px;
            font-weight: 500;
            margin-bottom: 0px;
          }

          .tags {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;

            .tag {
              border: 1px solid #F7DE3A;
              border-radius: 6px;
              padding: 4px 10px;
              font-size: 12px;
              background: rgba(247, 222, 58, 0.05);
              color: #344054;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  .custom-tooltip {
    display: flex;
    flex-direction: column;
    min-width: 180px;

    .item {
      display: flex;
      padding: 6px 0px;

      h5 {
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: 500;
        color: black;

        &.main {
          flex: 1;
        }
      }

      border-bottom: 1px solid #E1E1E1;

      &:last-of-type {
        border-bottom: 0px;
      }
    }
  }

  .empty-box {
    position: absolute;
    z-index: 500;
    bottom: var(--size-lg);
    left: var(--size-lg);
    padding: 12px 17px;
    width: 308px;
    background: white;
    border-radius: 4px;
    transition: .4s opacity;

    &.closed {
      opacity: 0;
    }

    .close-row {
      display: flex;
      justify-content: flex-end;

      svg {
        width: 10px;
        cursor: pointer;
      }
    }

    .header-row {
      display: flex;
      gap: 8px;

      img {
        height: 18px;
      }

      h4 {
        color: #344054;
        font-size: var(--font-size-lg);
        font-weight: 600;
        margin-bottom: 12px;
      }
    }

    p {
      color: #6C737F;
      font-weight: 600;
      font-size: 12px;
      max-width: 233px;
      line-height: 14.4px;
    }
  }
`;
